const testing = r => require.ensure([], () => r(require('@/page/testing')), 'testing');


export default [
  {
    path: '/testing',
    name: 'testing',
    component: testing
  }
];



// WEBPACK FOOTER //
// ./src/router/testing.js